"use client";

interface Props {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const TABS = [
  {
    id: "present",
    label: "Today",
    icon: (active: boolean) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.8">
        <path d="M12 2l2.09 6.26L20.18 9l-5 4.27L16.82 20 12 16.47 7.18 20l1.64-6.73L3.82 9l6.09-.74L12 2z" />
      </svg>
    ),
  },
  {
    id: "schedule",
    label: "Plan",
    icon: (active: boolean) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.8">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <path d="M16 2v4M8 2v4M3 10h18" />
        <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
      </svg>
    ),
  },
  {
    id: "decide",
    label: "Decide",
    icon: (active: boolean) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.8">
        <path d="M12 3v2m0 14v2M5.636 5.636l1.414 1.414m9.9 9.9l1.414 1.414M3 12h2m14 0h2M5.636 18.364l1.414-1.414m9.9-9.9l1.414-1.414" />
        <circle cx="12" cy="12" r="4" />
      </svg>
    ),
  },
  {
    id: "life",
    label: "Reflect",
    icon: (active: boolean) => (
      <svg width="22" height="22" viewBox="0 0 24 24" fill={active ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.8">
        <path d="M12 22c0-4-3-6-3-10a3 3 0 016 0c0 4-3 6-3 10z" />
        <path d="M7 14c-1.5-1-3-3.5-3-6a8 8 0 0116 0c0 2.5-1.5 5-3 6" />
      </svg>
    ),
  },
];

export default function BottomNav({ activeTab, onTabChange }: Props) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-border safe-area-bottom">
      <div className="flex items-center justify-around px-2 py-1">
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              data-testid={`nav-${tab.id}`}
              className={`flex flex-col items-center gap-0.5 py-2 px-4 rounded-xl transition-all duration-200 min-w-[64px]
                ${isActive
                  ? "text-primary"
                  : "text-muted hover:text-text-light"
                }`}
            >
              <div className={`transition-transform duration-200 ${isActive ? "scale-110" : ""}`}>
                {tab.icon(isActive)}
              </div>
              <span className={`text-[10px] font-medium ${isActive ? "text-primary" : ""}`}>
                {tab.label}
              </span>
              {isActive && (
                <div className="w-1 h-1 rounded-full bg-primary mt-0.5" />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
